export default __webpack_public_path__ + "media/images/restart-423a7e703d4fd74f108ee266654e622b.png";